let whiteList=['yzgl.oatongyuan.com']
export default {
	whiteList
}


// WEBPACK FOOTER //
// ./src/components/lzWps/config.js